export { PageRolesComponent as PageRoles } from './component';



// WEBPACK FOOTER //
// ./src/pages/roles/index.tsx